import { proxy } from 'valtio';

export const havanDialog = proxy({
  isOpen: false,
  location: '',
  eventUrl: '',
});
